import { Link } from 'react-router-dom';
import { Facebook, X, Instagram, Linkedin, Youtube, Phone, Mail, MapPin } from 'lucide-react';
import logo from '@/assets/aurakart-logo.png';

export function Footer() {
  return (
    <footer className="bg-foreground text-card">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <img src={logo} alt="AuraKart" className="h-12 mb-4 brightness-0 invert" />
            <p className="text-card/70 mb-4">
              Premium fashion for everyone. Discover curated collections for Boys, Girls, Ladies, and Men.
            </p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/profile.php?id=61585452327946" target="_blank" rel="noopener noreferrer" className="p-2 bg-card/10 rounded-full hover:bg-primary transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <div className="p-2 bg-card/10 rounded-full opacity-50 cursor-not-allowed">
                <X className="h-5 w-5" />
              </div>
              <a href="https://www.instagram.com/aurakartoffical/" target="_blank" rel="noopener noreferrer" className="p-2 bg-card/10 rounded-full hover:bg-primary transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <div className="p-2 bg-card/10 rounded-full opacity-50 cursor-not-allowed">
                <Linkedin className="h-5 w-5" />
              </div>
              <div className="p-2 bg-card/10 rounded-full opacity-50 cursor-not-allowed">
                <Youtube className="h-5 w-5" />
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/boys" className="text-card/70 hover:text-primary transition-colors">Boys</Link>
              </li>
              <li>
                <Link to="/category/girls" className="text-card/70 hover:text-primary transition-colors">Girls</Link>
              </li>
              <li>
                <Link to="/category/ladies" className="text-card/70 hover:text-primary transition-colors">Ladies</Link>
              </li>
              <li>
                <Link to="/category/men" className="text-card/70 hover:text-primary transition-colors">Men</Link>
              </li>
              <li>
                <Link to="/offers" className="text-card/70 hover:text-primary transition-colors">Offers</Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Customer Service</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/orders" className="text-card/70 hover:text-primary transition-colors">My Orders</Link>
              </li>
              <li>
                <Link to="/wishlist" className="text-card/70 hover:text-primary transition-colors">Wishlist</Link>
              </li>
              <li>
                <Link to="/profile" className="text-card/70 hover:text-primary transition-colors">My Account</Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-card/70 hover:text-primary transition-colors">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms" className="text-card/70 hover:text-primary transition-colors">Terms of Service</Link>
              </li>
              <li>
                <Link to="/refund-policy" className="text-card/70 hover:text-primary transition-colors">Refund Policy</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-card/70">+91 9345372307</p>
                  <p className="text-sm text-card/50">Mon-Sat, 9am-6pm</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                <p className="text-card/70">support@aurakartfashion.com</p>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                <p className="text-card/70">Chennai, Tamil Nadu, India</p>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-card/10 mt-10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-card/60 text-sm">
            © 2025 AURAKART. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/privacy-policy" className="text-card/60 hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-card/60 hover:text-primary transition-colors">Terms of Service</Link>
            <Link to="/refund-policy" className="text-card/60 hover:text-primary transition-colors">Refund Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
